<template>
  <section class="py-20">
    <div class="container mx-auto">
      <div v-reveal class="mb-12 text-center">
        <h2 class="mb-4 text-3xl font-bold text-ternary-dark dark:text-primary-light sm:text-4xl">
          Our own <span class="bg-gradient-to-r from-accent to-gradient-end bg-clip-text text-transparent">apps</span>
        </h2>
        <p class="mx-auto max-w-2xl text-lg text-gray-600 dark:text-gray-400">
          Products we designed, built and published ourselves. Private, offline-first, and on your phone today.
        </p>
      </div>

      <div class="grid gap-8 lg:grid-cols-2">
        <article
          v-for="(app, index) in apps"
          :key="app.slug"
          v-reveal="index * 140"
          class="overflow-hidden rounded-3xl bg-card-gradient shadow-soft dark:bg-card-gradient-dark"
        >
          <NuxtLink :to="`/projects/${app.slug}`" :aria-label="app.name" class="block overflow-hidden">
            <img
              :src="app.images[0]?.src"
              :alt="app.images[0]?.alt"
              width="1600"
              height="774"
              loading="lazy"
              class="aspect-[16/8] w-full object-cover transition-transform duration-500 hover:scale-105"
            >
          </NuxtLink>
          <div class="p-6 sm:p-8">
            <h3 class="mb-2 text-2xl font-bold text-ternary-dark dark:text-ternary-light">
              {{ app.name }}
            </h3>
            <p class="mb-6 text-gray-600 dark:text-gray-400">
              {{ app.subtitle }}
            </p>
            <div class="flex flex-wrap items-center justify-between gap-4">
              <StoreButtons :links="app.links ?? {}" />
              <NuxtLink :to="`/projects/${app.slug}`" class="inline-flex items-center font-semibold text-accent hover:text-gradient-end">
                Case study
                <PhArrowRight class="ml-2 size-4" />
              </NuxtLink>
            </div>
          </div>
        </article>
      </div>
    </div>
  </section>
</template>

<script setup lang="ts">
import { PhArrowRight } from '@phosphor-icons/vue'
import StoreButtons from '~/components/UI/StoreButtons.vue'
import { apps } from '~/utils/projects'
</script>
